import { useStepValidation } from '../../hooks';

export const useHardSkillsNavigation = () => {
  const { handleStepNavigation } = useStepValidation('HARD_SKILLS');

  const handleBeforeNavigate = () => {
    // Hard skills is optional - always allow navigation
    return true;
  };

  return {
    handleBeforeNavigate,
    handleStepNavigation
  };
};
